import request from '@/utils/request'
import qs from 'qs'

export function getStayComboList(data = {}) {
  return request({
    url: '/report-service/v1/report/combo',
    method: 'get',
    params: data
  })
}
export function getStayComboListExcel(query) {
  return request({
    url: '/report-service/v1/report/combo/to-excel',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false,
        skipNulls: true
      })
    },
    responseType: 'blob'
  })
}
export function getComboTypeList(data = {}) {
  return request({
    url: '/config-service/v1/package/package-group',
    method: 'get',
    params: data
  })
}
